import { QueryFactory } from '@lmt/shared-types';
import { forceTimezone } from '@lmt/unicorn-shared/app/helpers/timezone-change-helper';
import { useMemo } from 'react';

export const TimeZoneChangeHandler: React.FC<React.PropsWithChildren> = (
  props,
) => {
  const { data: calendarSettings, isLoading } =
    QueryFactory.CalendarSettingsQuery.useGetQuery({ throwOnError: false });

  useMemo(() => {
    if (calendarSettings?.timeZoneIanaId) {
      forceTimezone(calendarSettings.timeZoneIanaId);
    }
  }, [calendarSettings?.timeZoneIanaId]);
  return isLoading ? null : props.children;
};
